//request.js

import axios from "axios";
import {
  Message,
  Alert,
  MessageBox,
  //Loading
} from "element-ui";

import { getToken } from "@/api/api";

//1. 创建新的axios实例，
const service = axios.create({
  baseURL: process.env.BASE_API,
  //baseURL: '/baseIP',
  // 超时时间 单位是ms
  timeout: 160000,
});

let hasLogoutBox = false;

const err = (error) => {
  // console.log(error.message);
  /***** 接收到异常响应的处理开始 *****/
  //loadingInstance.close(); //关闭loading
  if (error.message != "artificial") {
    if (error.response) {
      // 1.公共错误处理
      // 2.根据响应码具体处理
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case 401:
          error.message = "未授权，请重新登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误,未找到该资源";
          //window.location.href = '/notFound';
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器端出错";
          break;
        case 501:
          error.message = "网络未实现";
          break;
        case 502:
          error.message = "网络错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网络超时";
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
      hasLogoutBox = false;
    } else {
      if (JSON.stringify(error).includes("timeout")) {
        // Message.error('服务器响应超时，请刷新当前页')
        error.message = `服务器响应超时，请刷新当前页`;
      } else {
        //error.message('连接服务器失败')
        error.message = `连接服务器失败，请刷新当前页`;
      }

      //服务器连接失败则弹出退出登录提示框。
      // MessageBox.confirm(
      // 	'连接服务器失败，您可以选择重新登录',
      // 	'确定登出', {
      // 		confirmButtonText: '重新登录',
      // 		cancelButtonText: '取消',
      // 		type: 'warning'
      // 	}
      // ).then(() => {
      // 	hasLogoutBox=true;
      // 	window.sessionStorage.clear(); //退出后清空window.sessionStorage里的内容。
      // 	location.reload()
      // })
      //return false;
      // window.sessionStorage.removeItem('token');
      // window.sessionStorage.removeItem('refreshToken');
    }
    Message.error(error.message);
  }

  /***** 处理结束 *****/
  // return Promise.resolve(error.response)
  return Promise.reject(error);
};

//请求拦截器
service.interceptors.request.use(function (config) {
  //发请求前做的一些处理，设置loading，数据转化，配置请求头，设置token等，根据需求去添加

  //loadingInstance = Loading.service(options); //显示loading,会导致页面flex布局高度发生短时间变化。

  config.data = JSON.stringify(config.data); //根据后端数据格式，可做相应的数据转换 JSON.stringify() 或 qs.stringify()
  //设置header的配置信息，跟后端配合设置
  config.headers = {
    //'Content-Type': 'application/x-www-form-urlencoded'
    "Content-Type": "application/json;charset=utf-8",
  };

  //设置 token ,根据需要设置
  //注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
  //const token = getCookie('token名称'); //这里取token之前，你肯定需要先拿到token,存一下

  const token = window.sessionStorage.getItem("token");
  const refreshToken = window.sessionStorage.getItem("refreshToken");
  // alert(token);
  if (token) {
    // config.params = {
    // 	'Authorization': token
    // };
    //config.headers.Authorization = "Bearer " + token;
    config.headers["Authorization"] = "Bearer " + token;
  }
  if (refreshToken) {
    config.headers["X-Authorization"] = "Bearer " + refreshToken;
  }

  // BIMSSO
  if (
    config.url.indexOf(process.env.VUE_APP_BIMSSO_API) >= 0 &&
    config.url.indexOf("/bimsso.ccshcc.cn:7000/api/GetToken") < 0 &&
    process.env.VUE_APP_ROUTE_PERMISSIONS == "verify"
  ) {
    let bimSsoPromise = new Promise(function (resolve, reject) {
      getToken().then((res) => {
        const token = res.data;
        config.headers["Authorization"] = "Bearer " + token;
        resolve(config);
      });
    });
    return bimSsoPromise;
  }

  return config;
}, err);

//响应拦截器
service.interceptors.response.use(function (response) {
  //loadingInstance.close(); //关闭loading
  console.log("response", response);
  if (response.headers["access-token"]) {
    window.sessionStorage.setItem("token", response.headers["access-token"]);
  }
  if (response.headers["x-access-token"]) {
    window.sessionStorage.setItem(
      "refreshToken",
      response.headers["x-access-token"]
    );
  }

  // if (response.request.responseType === 'blob') {
  //   return response
  // }
  //alert('1')
  const code = response.data.code;
  if (code === 401) {
    // alert(401);
    //alert('1')
    //现在是后端根据config.headers['Authorization']和config.headers['X-Authorization']自动刷新token，因此这里检测到401状态码后就直接跳转到登录页，同时清除本地token和refreshToken【不需要等到用户按确定按钮才清空】。
    // Alert('您的登录信息已失效，请重新登录。', '友情提醒', {
    // 	confirmButtonText: '确定',
    // 	type: "warning",
    // 	callback: action => {
    // 		window.location.reload()
    // 	}
    // });

    window.sessionStorage.setItem("tokenExpired", true);
    //避免连接服务器失败时，弹出不止一个退出登录的提示框。
    if (!hasLogoutBox) {
      hasLogoutBox = true;
      MessageBox.confirm(
        "您已被登出，可以取消继续留在该页面，或者重新登录",
        "确定登出",
        {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        if (sessionStorage.getItem("IsNew") == "new") {
          window.location.href = process.env.VUE_APP_NEW_URL + "/login";
        } else {
          window.sessionStorage.clear(); //退出后清空window.sessionStorage里的内容。
          location.reload();
          return Promise.reject(new Error(response.data.message || "Error"));
        }
      });
      window.sessionStorage.removeItem("token");
      window.sessionStorage.removeItem("refreshToken");
    }
  } else {
    window.sessionStorage.setItem("tokenExpired", false);
  }

  // console.log(response.headers);
  // console.log(33333333333);
  return response;
}, err);

export default service;
